/**
 * 데스크톱(Tauri) 전용 셸 동작.
 *
 * - 전체화면 토글: 데스크톱은 Tauri 창 API, 브라우저는 Fullscreen API
 * - 웹뷰가 브라우저처럼 보이는 동작 차단: 우클릭 메뉴, 텍스트 선택/드래그,
 *   새로고침·확대축소·검색 같은 단축키
 */

import { isDesktop } from './runtime';

let fullscreen = false;

/** 전체화면을 토글하고 최종 상태를 돌려준다. */
export async function toggleFullscreen(): Promise<boolean> {
  if (isDesktop()) {
    const { getCurrentWindow } = await import('@tauri-apps/api/window');
    const win = getCurrentWindow();
    const next = !(await win.isFullscreen());
    await win.setFullscreen(next);
    fullscreen = next;
    return next;
  }

  if (!document.fullscreenElement) {
    await document.documentElement.requestFullscreen().catch(() => undefined);
    fullscreen = Boolean(document.fullscreenElement);
  } else {
    await document.exitFullscreen().catch(() => undefined);
    fullscreen = false;
  }
  return fullscreen;
}

export function isFullscreen(): boolean {
  return isDesktop() ? fullscreen : Boolean(document.fullscreenElement);
}

/** 브라우저 티가 나는 기본 동작을 막는다. */
export function hardenShell(): void {
  document.addEventListener('contextmenu', (e) => e.preventDefault());
  document.addEventListener('selectstart', (e) => e.preventDefault());
  document.addEventListener('dragstart', (e) => e.preventDefault());

  // 데스크톱 앱에서는 새로고침/확대축소/인쇄/검색 단축키가 의미가 없다.
  // (개발 중 브라우저에서는 새로고침이 필요하므로 데스크톱에서만 막는다)
  if (!isDesktop()) return;

  window.addEventListener(
    'keydown',
    (e) => {
      const key = e.key.toLowerCase();
      const mod = e.ctrlKey || e.metaKey;
      const blocked =
        key === 'f5' ||
        (mod && ['r', 'p', 'f', 'g', 'u', 's', '+', '-', '=', '0'].includes(key));
      if (blocked) e.preventDefault();
    },
    { capture: true },
  );
}
